import { render, staticRenderFns } from "./salesOvertakeMoneyList.vue?vue&type=template&id=b480eed2"
import script from "./salesOvertakeMoneyList.vue?vue&type=script&lang=js"
export * from "./salesOvertakeMoneyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports